export default __webpack_public_path__ + "static/media/1left.064dbd23.png";